import React, { Component, Fragment } from 'react';
import { Button, Container, Row, Col, Form, Jumbotron, Table } from 'react-bootstrap';
import config from '../../../config';

import SearchItem from '../../subcomponent/searchItem';
import errores from '../../../middleware/errordb'
import { CSVLink } from "react-csv";

export class reporteExitencia extends Component {
    constructor(props) {
        super(props);
        const currentCompany = sessionStorage.getItem('company');

        this.state = {
            empresa: currentCompany,
            tipo_reporte: "",
            bodega: "",
            tipo_inv: "",
            cat_inv: "",
            linea_inv: "",
            item: "",
            list_tipo: [],
            list_categorias: [],
            list_lineas: [],
            list_items: [],
            list_bodegas: [],
            currentItem: [],
            infoReporte: []
        }

    }

    componentDidMount() {
        const datasend = {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'empresa': this.state.empresa,
                'tipo': this.state.tipo,
            }
        }
        fetch(config.servBackEnd + '/reports/inventory', datasend).then(response => response.json())
            .then(data => {
                if (data.ok) {
                    const datos = data.data;
                    this.setState({
                        list_items: datos[0],
                        list_bodegas: datos[1],
                        list_tipo: datos[2],
                        list_categorias: datos[3],
                        list_lineas: datos[4]
                    });
                } else {
                    this.setState({ mostrarMensaje: true, mensaje: data.message })
                }
            });
    }

    initReporte = () => {
        const { empresa } = this.state;
        const { bodega } = this.state;
        const { item, tipo_inv, cat_inv, linea_inv } = this.state;

        const datasend = {
            method: 'POST',
            body: JSON.stringify({
                empresa,
                bodega,
                item,
                tipo_inv,
                cat_inv,
                linea_inv
            }),
            headers: {
                'Content-Type': 'application/json',
                'tipo': this.state.tipo,
                'empresa': empresa
            }
        }
        fetch(config.servBackEnd + '/reports/inventoryexistence', datasend).then(response => response.json())
            .then(data => {
                if (data.ok) {
                    this.setState({ infoReporte: data.data });
                } else {
                    this.setState({ infoReporte: [], mostrarMensaje: true, mensaje: "Ingreso con errores:" + errores[data.code] + " " + data.message })
                }
            });
    }

    addItem = (selectItem) => {
        this.setState({
            currentItem: selectItem,
            item: selectItem.ID_ITEMS
        });
    }
    filterItems = (data) => {
        const tmpData = [];
        const { tipo_inv, cat_inv, linea_inv } = this.state;
        data.forEach(element => {
            if (
                ((element.GRUPO_ITEM || "").toString() === cat_inv.toString() || cat_inv.toString() === "") &&
                ((element.LINEA_ITEM || "").toString() === linea_inv.toString() || linea_inv.toString() === "") &&
                ((element.TIPO_ITEM || "").toString() === tipo_inv.toString() || tipo_inv.toString() === "")
            ) {
                tmpData.push(element);
            }
        });
        return tmpData;
    }
    render() {
        const { list_bodegas, tipo_inv, cat_inv, list_tipo, list_categorias, list_lineas } = this.state;
        const { currentItem } = this.state;
        const { infoReporte } = this.state;
        const filtered_list_items = this.filterItems(this.state.list_items);
        return (
            <Fragment>

                <Jumbotron className="Jumbotron">
                    <h2>Reporte de exitencias</h2>
                </Jumbotron>
                <Container fluid>
                    <Row className="justify-content-md-center" >
                        <Col className="mb-2" xs={5} lg={2}>REPORTE POR</Col>
                        <Col className="mb-2" xs={7} lg={3}>
                            <Form.Control as="select" onChange={e => this.setState({ tipo_reporte: e.target.value, currentItem: [], item: "", bodega: "" })} value={this.state.tipo_reporte} >
                                <option value=""></option>
                                <option value="i">Items</option>
                                <option value="b">Bodega</option>
                            </Form.Control>
                        </Col>
                    </Row>
                    <Row>
                        {(this.state.tipo_reporte === "b") &&
                            <Col>
                                <Form.Group as={Row} controlId="formPlaintextEmail">
                                    <Form.Label column sm="2">
                                        Seleccione Bodega
                                    </Form.Label>
                                    <Col sm="10">
                                        <Form.Control as="select" onChange={e => this.setState({ bodega: e.target.value })} value={this.state.bodega} required >
                                            <option value="">Seleccione</option>
                                            {
                                                list_bodegas.map((bodega, i) => {
                                                    return (<option key={'b' + i} value={bodega.ID_BODEGAS}>{bodega.DESCRIPCION_BODEGA}</option>)
                                                })
                                            }
                                        </Form.Control>
                                    </Col>
                                </Form.Group>
                            </Col>
                        }
                        {(this.state.tipo_reporte === "i") &&
                            <Fragment>
                                <Col className="mb-2" xs={5} lg={1}>Tipo Inventario</Col>
                                <Col className="mb-2" xs={7} lg={2}>
                                    <Form.Control as="select" onChange={e => this.setState({ tipo_inv: e.target.value, infoReporte: [], linea_inv: "", cat_inv: "" })} value={this.state.tipo_inv} required >
                                        <option value="">Seleccione</option>
                                        {
                                            list_tipo.map((tipo, i) => {
                                                return (<option key={'t' + i} value={tipo.ID_TIPO_INVENTARIO}>{tipo.DESCRIPCION_TIPO_INV}</option>)
                                            })
                                        }
                                    </Form.Control>
                                </Col>
                                <Col className="mb-2" xs={5} lg={1}>Grupo Inventario</Col>
                                <Col className="mb-2" xs={7} lg={2}>
                                    <Form.Control as="select" onChange={e => this.setState({ cat_inv: e.target.value, infoReporte: [], linea_inv: "" })} value={this.state.cat_inv} required >
                                        <option value="">Seleccione</option>
                                        {
                                            list_categorias.map((tipo, i) => {
                                                if ((tipo.ID_TIPO_INVENTARIO || "").toString() === tipo_inv.toString() || tipo_inv.toString() === "") {
                                                    return (<option key={'c' + i} value={tipo.ID_GRUPO_INVENTARIO}>{tipo.DESCRIPCION_GRUPO_INV}</option>)
                                                } else {
                                                    return null;
                                                }
                                            })
                                        }
                                    </Form.Control>
                                </Col>
                                <Col className="mb-2" xs={5} lg={1}>Linea Inventario</Col>
                                <Col className="mb-2" xs={7} lg={2}>
                                    <Form.Control as="select" onChange={e => this.setState({ linea_inv: e.target.value, infoReporte: [] })} value={this.state.linea_inv} required >
                                        <option value="">Seleccione</option>
                                        {
                                            list_lineas.map((linea, i) => {
                                                if (((linea.ID_TIPO_INVENTARIO || "").toString() === tipo_inv.toString() || tipo_inv.toString() === "") &&
                                                    ((linea.ID_GRUPO_INVENTARIO || "").toString() === cat_inv.toString() || cat_inv.toString() === "")
                                                ) {
                                                    return (<option key={'l' + i} value={linea.ID_LINEA_INVENTARIO}>{linea.DESCRIPCION_LINEA_INV}</option>)
                                                } else {
                                                    return null;
                                                }
                                            })
                                        }
                                    </Form.Control>
                                </Col>
                                <Col>
                                    <SearchItem data={filtered_list_items} event={this.addItem} clean={true} ></SearchItem>
                                </Col>
                                <Col>
                                    <Form.Group controlId="exampleForm.ControlInput1">
                                        <Form.Label>Item Seleccionado</Form.Label>
                                        <Form.Control type="text" value={(currentItem.REFERENCIA_ITEM || "-") + " - " + (currentItem.DESCRIPCION_ITEM || "-")} plaintext readOnly />
                                    </Form.Group>
                                </Col>
                            </Fragment>
                        }
                    </Row>
                    <Row>
                        <Col>
                            <Button disabled={this.state.tipo_reporte === ""} onClick={this.initReporte} className="m-3" name="actualizar" >Generar Reporte</Button>
                            <CSVLink data={infoReporte} filename={"INVENTARIO.csv"} separator={";"}>
                                <Button disabled={infoReporte.length === 0} variant="success">Descargar Reporte</Button>
                            </CSVLink>
                            {/* <Button disabled={this.state.tipo_reporte === ""} onClick={this.initReporte} className="m-3" name="descargar" ></Button> */}
                        </Col>
                    </Row>
                </Container>
                <Container>
                    <Table striped bordered hover>
                        <thead>
                            <tr>
                                <td>BODEGA</td>
                                <td>REFERENCIA</td>
                                <td>DESCRIPCION</td>
                                <td>CANTIDAD</td>
                                <td>COSTO PROMEDIO</td>
                                <td>COSTO TOTAL</td>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                infoReporte.map((element, i) => {
                                    return (<tr key={'tr' + i}>
                                        <td>{element.BODEGA}</td>
                                        <td>{element.REFERENCIA_ITEM}</td>
                                        <td>{element.DESCRIPCION_ITEM}</td>
                                        <td>{element.CANTIDAD}</td>
                                        <td className="currSign"> {Intl.NumberFormat('es-MX').format(element.COSTO_PONDERADO)}</td>
                                        <td className="currSign"> {Intl.NumberFormat('es-MX').format(element.COSTO_PONDERADO * element.CANTIDAD)}</td>
                                    </tr>);
                                })
                            }
                        </tbody>
                    </Table>
                </Container>
            </Fragment>
        )
    }
}

export default reporteExitencia



// WEBPACK FOOTER //
// ./src/components/bussines/inventarios/reporteExitencia.jsx